import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import fotoPerfil from "../../img/fotoPerfil.jpg";

export default function Cards() {
  return (
    <section id="inicio" className="pf-hero">
      <div className="container">
        <div className="row align-items-center">

          {/* Texto */}
          <div className="col-lg-7 order-2 order-lg-1">
            <p className="pf-hero__greeting">Full-Stack Developer</p>
            <h1 className="pf-hero__name">
              Hola, soy<br />
              <span style={{ color: "var(--accent)" }}>Ricardo López Ortiz</span>
            </h1>
            <p className="pf-hero__role">
              Ingeniero en Sistemas Computacionales
            </p>
            <p className="pf-hero__desc">
              Me apasiona crear soluciones tecnológicas que combinan funcionalidad,
              rendimiento y una excelente experiencia de usuario. Enfocado en la
              calidad del código, la escalabilidad y el impacto en los procesos de negocio.
            </p>

            <div className="pf-hero__actions">
              <a href="#proyectos" className="btn-pf-primary">Ver proyectos</a>
              <a href="/CV_Ricardo_Lopez.pdf" download className="btn-pf-outline">Descargar CV</a>
            </div>

            <div className="pf-hero__socials">
              <a href="https://github.com/Swankestriver" target="_blank" rel="noopener noreferrer" className="pf-hero__social-link">
                <FaGithub size={18} /> GitHub
              </a>
              <a href="https://www.linkedin.com/in/ricardo-lopez-ortiz-9b5625240/" target="_blank" rel="noopener noreferrer" className="pf-hero__social-link">
                <FaLinkedin size={18} /> LinkedIn
              </a>
              <a href="mailto:ricardo991120@gmail.com" className="pf-hero__social-link">
                <FaEnvelope size={18} /> Email
              </a>
            </div>
          </div>

          {/* Foto */}
          <div className="col-lg-5 order-1 order-lg-2 mb-5 mb-lg-0 pf-hero__photo-wrap">
            <div className="pf-hero__photo-ring">
              <img
                src={fotoPerfil}
                alt="Ricardo López Ortiz"
                className="pf-hero__photo"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
